export function getAnualMesLabel(idMes){
    const meses=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']

    const ano = Math.floor(idMes/12)
    const mes = idMes % 12

    return `${meses[mes]} ${ano}`
}